export const PartsAndLaborGuideActionTypes = {
  SET_PL_GUIDE_STATE: 'SET_PL_GUIDE_STATE',
  RESET_PL_STATE: 'RESET_PL_STATE',
};
Object.freeze(PartsAndLaborGuideActionTypes);
